import { render, staticRenderFns } from "./ResumenBiasMail.vue?vue&type=template&id=8e226b4c&scoped=true&"
import script from "./ResumenBiasMail.vue?vue&type=script&lang=js&"
export * from "./ResumenBiasMail.vue?vue&type=script&lang=js&"
import style0 from "./ResumenBiasMail.vue?vue&type=style&index=0&id=8e226b4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e226b4c",
  null
  
)

export default component.exports